export * from './baMenu.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baMenu/index.ts